import { useEffect } from 'react';
import { setPerfDebugModeEnabled } from '@framework/utils/perfDebugMode';
import { isDebugMode } from '@framework/utils/WithDebugMode';
import { useCurrentUserIsLeviiStaff } from './UserEntity/useCurrentUserIsLeviiStaff';

const PerfDebugModeResolver: React.FC = () => {
  const isLeviiStaff = useCurrentUserIsLeviiStaff();

  useEffect(() => {
    setPerfDebugModeEnabled(isLeviiStaff);
    return () => setPerfDebugModeEnabled(false);
  }, [isLeviiStaff]);

  return null;
};

/**
 * `?debug=perf` のパフォーマンス計測機能を Levii ドメインのユーザにだけ有効化する。
 *
 * debug=perf でないときはユーザ情報の購読自体を行わないよう、内側のコンポーネントに分けている。
 */
export const PerfDebugModeSync: React.FC = () => {
  if (!isDebugMode('perf')) return null;

  return <PerfDebugModeResolver />;
};
